module.exports = __webpack_public_path__ + "img/rmolog.f48db272.png";